import React from 'react';

const NoListFallback = () => (
  <div className="NoListFallback">
    <h3>This is unexpected.</h3>
    <p>We're sorry, we're not sure how you got here! No list could be loaded.</p>
  </div>
);

export default NoListFallback;